import { call, put, select } from 'redux-saga/effects';
import {
  getByName as getByNameBit,
} from '../bitSagas/getByName';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { actions as taggingActions } from '../reducers/tagging';
import { actions as apisNeedsActions } from '../reducers/apisNeeds'
import { normalizePurchasePriceInfo } from './normalizers/customizer';
import { commonActions } from '../reducers/common';

const flowStore = state => state.flow;
const apisNeedsStore = state => state.apiNeeds;
const offerStore = state => state.offer;

export function* getByName(input) {
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));
  const {
    showError,
    normalizeHttpErrors,
    name,
    successUpdate,
    custoType,
  } = input;
  const reduxUpdate = {
    successUpdate,
    errorUpdate: showError,
  };

  const getByNameParams = {
    name,
    reduxUpdate,
    normalizeHttpErrors,
    custoType,
  };

  let response = null;
  try {
    response = yield call(getByNameBit, getByNameParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* getPurchasePriceChange(input) {
  const CREATIVITY_NAME = 'TELCO-Purchase-Price-Change';
  const {
    showError,
  } = input;
  const reduxUpdate = {
    errorUpdate: showError,
  };
  const getByNameParams = {
    ...input,
    name: CREATIVITY_NAME,
    custoType: 'creativity',
    reduxUpdate,
  };

  try {
    const response = yield call(getByNameBit, getByNameParams);
    if (response) {
      const flowInfo = yield select(flowStore);
      const { productOfferingsToBuyInfo, hasPromotionApplied } = yield select(apisNeedsStore);
      const { actualProductOffering } = yield select(offerStore);
      let productOfferingTypes = [];
      if (productOfferingsToBuyInfo[actualProductOffering]) {
        productOfferingTypes = productOfferingsToBuyInfo[actualProductOffering].productOfferingTypes || '';
      }
      const { flowJson } = flowInfo;
      const { flowName } = flowJson;
      const priceChangeInfo = normalizePurchasePriceInfo(flowName, response, productOfferingTypes, hasPromotionApplied);
      if (priceChangeInfo) {
        yield put(commonActions.setPricesChangesInfo(priceChangeInfo));
      }
    }
    return null;
    
  } catch (error) {
    return null;
  }
}

export function* getAfterSaleProducts(input) {
  const CREATIVITY_NAME = 'TELCO-After-Sale-Products';
  const {
    showError,
  } = input;
  const reduxUpdate = {
    errorUpdate: showError,
  };
  const getByNameParams = {
    ...input,
    name: CREATIVITY_NAME,
    custoType: 'creativity',
    reduxUpdate,
  };

  const response = yield call(getByNameBit, getByNameParams);
  if (response) {
    const { cisi, productOffering } = yield select(offerStore);

    if (cisi && response.products && Array.isArray(response.products)) {
      const cisiSelected = response.products.find(product => product.cisi === cisi);

      if (cisiSelected) {
        yield put(taggingActions.setManualProductOffering({ productOffering: cisiSelected.cisi }));
        yield put(taggingActions.setAliasSellingProduct(cisiSelected.name));
        yield put(apisNeedsActions.setAfterSaleProduct(cisiSelected));
      }
    }
    if (productOffering && response.products && Array.isArray(response.products)) {
      const productSelected = response.products.find(product => product.poId === productOffering);

      if (productSelected) {
        yield put(apisNeedsActions.setAfterSaleProduct(productSelected));
      }
    }
  }
  return null;
}
